module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"weather-widget:time-now":"Сейчас"},"en":{"weather-widget:time-now":"Now"}}')
  delete Component.options._Ctor
}
